<!--
 * @Author: ljc_625738144@qq.com
 * @Date: 2024-08-15 16:05:37
 * @LastEditors: ljc_625738144@qq.com
 * @LastEditTime: 2024-10-09 15:16:44
 * @Description: 基础弹框组件
 * @FilePath: \haozhang_pro\src\components\dialog\BaseDialog.vue
-->
<template>
  <el-dialog
    :title="title"
    :visible.sync="isShow"
    :close-on-click-modal="isClickModalClose"
    :width="getWidthSize"
    :custom-class = "className"
    @close="handleClose"
    id="account_new_dialog"
  >
    <div slot="title">
      <div class="account_new_dialog__title">{{title}}</div>
      <!-- <slot name="title"></slot> -->
    </div>
    <div class="account_new_dialog__content">
      <slot name="content"></slot>
    </div>
    <span slot="footer" class="dialog-footer">
      <div v-if = "isCancel || isConfirm" class="account_new_dialog__footer">
        <AccBtn :width = 'getBtnSize' type = "2" text = "取消" @click = "handleClose" v-if = "isCancel"/>
        <AccBtn :width = 'getBtnSize' @click = "handleConfirm" v-if = "isConfirm" :text="text"/>
      </div>
    </span>
  </el-dialog>
</template>
<script>
import { DIALOG_SIZE,BUTTON_SIZE } from '@/assets/js/constant';
import AccBtn from "@/components/accBtn"
export default {
  props: {
    text:{
      type:String,
      default:'确定'
    },
    isClickModalClose: {
      type: Boolean,
      default: false
    },
    showVisible: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => { }
    },
    isCancel: {
      type: Boolean,
      default: true
    },
    isConfirm: {
      type: Boolean,
      default: true
    },
    className: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: '请设置弹框标题'
    },
    size: {
      type: String,
      default: 'MEDIUM'  //  DIALOG_SIZE.MEDIUM | DIALOG_SIZE.SMALL | DIALOG_SIZE.LARGE
    }
  },
  components: {
    AccBtn
  },
  computed: {
    isShow: {
      get() {
        return this.showVisible;
      },
      set(val) {
        this.$emit('update:showVisible', val);
      }
    },
    getBtnSize() {
      return BUTTON_SIZE[this.size]
    },
    getWidthSize() {
      return DIALOG_SIZE[this.size]
    }
  },
  data() {
    return {
    };
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    handleConfirm() {
      this.$emit('confirm');
    }
  }
};
</script>
<style lang="less">
.account_new_dialog__title {
  font-size:16px;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/BaseDialog.vue